import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { AddSavedColorsToCollectionButton } from "./components/my-saved-colors/add-saved-colors-to-collection-button";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";

const AddSavedColorsToCollectionContext = createContext();
export const useAddSavedColorsToCollection = () =>
  useContext(AddSavedColorsToCollectionContext);
function AddSavedColorsToCollectionProvider({ data, children }) {
  return (
    <AddSavedColorsToCollectionContext.Provider value={data}>
      {children}
    </AddSavedColorsToCollectionContext.Provider>
  );
}

function AddSavedColorsToCollectionRenderer() {
  const elements = document.querySelectorAll(
    ".react-add-saved-colors-to-collection"
  );
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for AddSavedColorsToCollection"
      );
    }
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <AddSavedColorsToCollectionProvider data={initialProps}>
            <AddSavedColorsToCollectionButton />
          </AddSavedColorsToCollectionProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initAddSavedColorsToCollection = () => {
  if (document.readyState !== "loading") {
    AddSavedColorsToCollectionRenderer();
  } else {
    document.addEventListener(
      "DOMContentLoaded",
      AddSavedColorsToCollectionRenderer
    );
  }
};
